export default "__VITE_ASSET__D_9s3BwG__"